import {
  DeleteRounded as DeleteRoundedIcon,
  EditRounded as EditRoundedIcon,
  LockOpenRounded as LockOpenRoundedIcon,
  LockRounded as LockRoundedIcon
} from '@mui/icons-material'
import { Box, ButtonGroup, Card, CardActions, CardHeader, Divider, Grid, IconButton, Typography } from '@mui/material'
import { t } from 'i18next'
import moment from 'moment'

import Can from '../../Layout/Can/Can'
import Show from '../../Layout/Can/Show'

const ZCard = ({
  sx = [],
  id,
  title,
  titleImage,
  titleInfo,
  subheader,
  content,
  createdAt,
  updatedAt,
  onDelete,
  onEdit,
  deleteAriaLabel = t('common.delete'),
  editAriaLabel = t('common.edit'),
  lockAriaLabel,
  onLock,
  name = '',
  footerFields = [],
  isEditVisible = true,
  isDeleteVisible = true,
  isLockVisible = false,
  isEntityLocked = false,
  variant = 'elevation',
  action = '',
  actionDelete = '',
  actionUpdate = ''
}) => {
  return (
    <Card
      name={name}
      id={id}
      sx={[{ marginBottom: 5 }, ...(Array.isArray(sx) ? sx : [sx])]}
      variant={variant}>
      <CardHeader
        name={`${name}-card-header`}
        subheader={
          <Typography
            component="p"
            variant="body2">
            {subheader}
          </Typography>
        }
        title={
          <Grid
            container
            justifyContent="space-between">
            <Grid
              container
              direction="row"
              columnGap={2}>
              <Show when={() => titleImage}>{titleImage}</Show>
              <Grid>
                <Typography component="p">
                  <strong>{title}</strong>
                </Typography>
              </Grid>
            </Grid>
            <Grid>{titleInfo}</Grid>
          </Grid>
        }
      />
      {content}
      <Divider variant="middle" />
      <CardActions>
        <Box sx={{
          flexGrow: 1,
          paddingX: 2
        }}>
          <Grid
            container
            spacing={2}>
            {footerFields
              .filter((f) => f.value)
              .map(({ label, value }, index) => (
                <Grid
                  key={`addition-info-${index}`}
                  size={3}>
                  <Typography
                    variant="body2"
                    sx={{ color: '#7B8DA0' }}>
                    {label}: <strong>{value}</strong>
                  </Typography>
                </Grid>
              ))}
            <Grid size={3}>
              <Show when={() => createdAt}>
                <Typography variant="body2">
                  {t('common.createdAt')}: <strong>{moment(createdAt).format('DD.MM.YYYY HH:mm')}</strong>
                </Typography>
              </Show>
            </Grid>
            <Grid size={3}>
              <Show when={() => updatedAt}>
                <Typography variant="body2">
                  {t('common.updatedAt')}: <strong>{moment(updatedAt).format('DD.MM.YYYY HH:mm:ss')}</strong>
                </Typography>
              </Show>
            </Grid>
            <Grid
              size="grow"
              display="flex"
              justifyContent="flex-end">
              <ButtonGroup size="small">
                <Can
                  action={action}
                  expression={() => isLockVisible}>
                  <IconButton
                    id={`${id}-lock`}
                    variant="text"
                    key="lock"
                    aria-label={lockAriaLabel || t(isEntityLocked ? 'common.unlock' : 'common.lock')}
                    color={isEntityLocked ? 'error' : 'primary'}
                    onClick={onLock}>
                    {isEntityLocked ? <LockRoundedIcon fontSize="small" /> : <LockOpenRoundedIcon fontSize="small" />}
                  </IconButton>
                </Can>
                <Can
                  action={actionDelete ? actionDelete : action}
                  expression={() => isDeleteVisible}>
                  <IconButton
                    id={`${id}-delete`}
                    variant="text"
                    key="trash"
                    aria-label={deleteAriaLabel}
                    onClick={onDelete}
                    color="error">
                    <DeleteRoundedIcon fontSize="small" />
                  </IconButton>
                </Can>
                <Can
                  action={actionUpdate ? actionUpdate : action}
                  expression={() => isEditVisible}>
                  <IconButton
                    id={`${id}-edit`}
                    variant="text"
                    key="edit"
                    aria-label={editAriaLabel}
                    color="primary"
                    onClick={onEdit}>
                    <EditRoundedIcon fontSize="small" />
                  </IconButton>
                </Can>
              </ButtonGroup>
            </Grid>
          </Grid>
        </Box>
      </CardActions>
    </Card>
  )
}

export default ZCard
